import { QueryClient } from "@tanstack/react-query";

export const createQueryClient = (): QueryClient => {
  try {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: (failureCount, error) => {
            // Don't retry on certain errors
            if (error instanceof Error && error.message.includes('network')) {
              return failureCount < 2;
            }
            return failureCount < 1;
          },
          staleTime: 5 * 60 * 1000, // 5 minutes
          refetchOnWindowFocus: false,
        },
        mutations: {
          retry: 1,
        },
      },
    });
  } catch (error) {
    console.error('Failed to create QueryClient:', error);
    // Return a minimal client as fallback
    return new QueryClient();
  }
};